import PagerViewWeb from './PagerView.web'

export default PagerViewWeb
